const ModuleName = "md_select";
const ModuleDefaults = {
  data: {},
  whenOpen() {
    console.log("open func");
  },
  whenClose() {
    console.log("close func");
  },
  whenSelect: (e) => {
    console.log("select func");
  },
};

class Module {
  constructor(ele, options) {
    this.ele = ele;
    this.$ele = $(ele);
    this.option = options;
    // select dom
    this.$selectWrap = this.$ele.find(".md_select_wrap");
    this.$currentSelect = this.$ele.find(".md_select_current");
    this.$selectList = this.$ele.find(".md_select_select_list");
  }

  init() {
    //module init doing
    if (this.$selectWrap.length == 0) {
      this.renderSelectWrap();
    }

    this.initSelectedStatus();
    this.outSideClickClose();
    this.resetSelect();
    this.registSelectClickEvent();
    this.registTriggerOpenEvent();
    this.registTriggerCloseEvent();
    this.registTriggerToggleEvent();
  }

  renderSelectWrap() {
    let self = this;
    let $label = self.$ele.find(".md_select_label");
    let wrapHtml = "<div class='md_select_wrap'></div>";
    let selectInputHtml = "<div class='md_select_input'>請選擇</div>";
    let selectListHtml = "<ul class='md_select_select_list'></ul>";
    let dropDownIconHtml =
      "<span class='md_icon icon_arrow_drop_down'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 -960 960 960' fill='none'><path xmlns='http://www.w3.org/2000/svg' d='M480-360 280-560h400L480-360Z' fill='black' /></svg></span>";
    $label.after(wrapHtml);

    let $selectWrap = self.$ele.find(".md_select_wrap");
    $selectWrap.append(selectInputHtml);
    $selectWrap.append(dropDownIconHtml);
    $selectWrap.append(selectListHtml);

    let $selectList = self.$ele.find(".md_select_select_list");

    if (Array.isArray(self.option.data) && self.option.data.length > 0) {
      self.option.data.forEach((item) => {
        const disabled = item.disabled ? "disabled" : "";
        const selected = item.selected ? "selected" : "";

        $selectList.append(
          `<li value="${item.value}" ${disabled} ${selected}>${item.text}</li>`,
        );
        self.$currentSelect.append(
          `<option value="${item.value}" ${disabled} ${selected}>${item.text}</option>`,
        );
      });
    } else {
      self.$currentSelect.find("option").each((index, ele) => {
        console.log("ele", $(ele).val(), $(ele).text());
        const disabled = $(ele).is(":disabled") ? "disabled" : "";
        const selected = $(ele).is(":selected") ? "selected" : "";

        $selectList.append(
          `<li value="${$(ele).val()}" ${disabled} ${selected}>${$(ele).text()}</li>`,
        );
      });
    }

    this.$selectList = $selectList;
  }

  // 抓到有設 selected 的值
  initSelectedStatus() {
    const self = this;
    const selectedOption = self.$currentSelect.find("option:selected");

    // 瀏覽器預設的 option 要排除
    if (!selectedOption.length || selectedOption.prop("defaultSelected") === false) {
      return;
    }
    const selectedText = selectedOption.text();
    const selectedValue = selectedOption.val();

    // 顯示初始值
    self.$ele
      .find(".md_select_input")
      .html(`${selectedText}<span class='md_select_arrow_drop_down'></span>`);
    // 加上 .selected 到對應的 li
    self.$selectList.find("li").removeClass("selected");
    self.$selectList.find(`li[value="${selectedValue}"]`).addClass("selected");
  }

  resetSelect() {
    // md_select_current 需要有 selected

    const self = this;

    // 抓 HTML 一開始 selected 的那個 option
    const defaultSelectOption = self.$currentSelect
      .find("option")
      .filter((index, ele) => ele.defaultSelected);

    const selectedText = defaultSelectOption.text();
    const selectedValue = defaultSelectOption.val();

    self.$ele
      .find(".md_select_input")
      .html(`${selectedText}<span class='md_select_arrow_drop_down'></span>`);
    self.$selectList.find("li").removeClass("selected");
    self.$selectList.find(`li[value="${selectedValue}"]`).addClass("selected");
  }

  outSideClickClose() {
    let self = this;
    $(document).on("click.md_select", (e) => {
      const $target = $(e.target);

      if (
        self.$selectList.hasClass("open") &&
        !$target.closest(".md_select_wrap").length // 排除選單本身
      ) {
        self.$ele.trigger("onClose");
        if (self.option.whenClose) self.option.whenClose(e);
      }
    });
  }

  registSelectClickEvent() {
    let self = this;

    self.$selectList.on("click", " li", function (e) {
      e.stopPropagation();

      if ($(this).attr("disabled") !== undefined) {
        return; // 禁用 disabled 的選項
      }

      const selectedText = $(this).text();
      const selectedValue = $(this).attr("value");

      self.$ele
        .find(".md_select_input")
        .html(`${selectedText}<span class='md_select_arrow_drop_down'></span>`);

      self.$currentSelect.val(selectedValue).trigger("change");

      self.$selectList.find("li").removeClass("selected");
      $(this).addClass("selected");

      self.$ele.trigger("onClose");
      if (self.option.whenSelect) self.option.whenSelect(selectedText, selectedValue, e);
    });

    self.$ele.on("click", (e) => {
      if (self.$selectList.hasClass("open")) {
        self.$ele.trigger("onClose");
        if (self.option.whenClose) self.option.whenClose(e);
      } else {
        self.$ele.trigger("onOpen");
        if (self.option.whenOpen) self.option.whenOpen(e);
      }
    });
  }

  registTriggerOpenEvent() {
    let self = this;
    self.$ele.on("onOpen", () => {
      self.$selectList.addClass("open");
    });
  }

  registTriggerCloseEvent() {
    let self = this;
    self.$ele.on("onClose", () => {
      self.$selectList.removeClass("open");
    });
  }

  registTriggerToggleEvent() {
    let self = this;
    self.$ele.on("toggle", () => {
      self.$selectList.toggleClass("open");
    });
  }
}

$.fn[ModuleName] = function (options) {
  return this.each(function () {
    var $this = $(this);
    var module = $this.data(ModuleName);
    var opts = null;
    if (module) {
      if (typeof options === "string") {
        module[options]();
      } else {
        throw "unsupported options!";
      }
    } else {
      opts = $.extend({}, ModuleDefaults, typeof options === "object" && options);
      module = new Module(this, opts);
      $this.data(ModuleName, module);
      module.init();
    }
  });
};
